import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import { CREDIT_KARMA_OFFER_ENABLED } from "@/config/featureFlags";
import { Navigate } from "@/lib/router-compat";
import LifeMartFreeCreditScore from "@/pages/LifeMartFreeCreditScore";

// Kept live as of 2026-08-06 (reversed an earlier same-day gating decision
// this session) -- /lifemart/stack-offer is gated instead.
export const Route = createFileRoute("/lifemart/free-credit-score")({
  head: () => seoHead("/lifemart/free-credit-score"),
  component: () => (CREDIT_KARMA_OFFER_ENABLED ? <LifeMartFreeCreditScore /> : <Navigate to="/credit-readiness" replace />),
});
